import { client } from "../client";
import { AO_HOST } from "../client/aoHost";

/**
 * Renders the per-area player list as a column of cards: character icon on
 * the left, then character / showname / OOC name stacked beside it -- the
 * full set of fields the old table showed. No moderator buttons (the client
 * has no mod-status flag, and the server enforces mod-only actions anyway).
 */
export function renderPlayerList() {
  const list = document.getElementById("client_playerlist")!;
  list.innerHTML = "";

  let shown = 0;
  for (const [playerID, player] of client.playerlist) {
    if (player.area !== client.area) continue;
    shown++;

    const entry = document.createElement("div");
    entry.className = "playerlist-entry";
    entry.id = `client_playerlist_entry${playerID}`;

    const img = document.createElement("img");
    img.className = "playerlist-icon";
    img.loading = "lazy";
    if (player.charName) {
      const iconExt = client.charicon_extensions[0] || ".png";
      img.src = `${AO_HOST}characters/${encodeURI(
        player.charName.toLowerCase(),
      )}/char_icon${iconExt}`;
      img.alt = player.charName;
      img.title = player.charName;
    }

    const info = document.createElement("div");
    info.className = "playerlist-info";

    const charLine = document.createElement("div");
    charLine.className = "playerlist-char";
    charLine.textContent = player.charName
      ? `${player.charName} [${playerID}]`
      : `Spectator [${playerID}]`;
    info.appendChild(charLine);

    // Showname (the in-character display name), when set.
    if (player.showName) {
      const showLine = document.createElement("div");
      showLine.className = "playerlist-showname";
      showLine.textContent = `“${player.showName}”`;
      info.appendChild(showLine);
    }

    // OOC username, when set.
    if (player.name) {
      const oocLine = document.createElement("div");
      oocLine.className = "playerlist-ooc";
      oocLine.textContent = `OOC: ${player.name}`;
      info.appendChild(oocLine);
    }

    entry.append(img, info);
    list.appendChild(entry);
  }

  if (shown === 0) {
    const empty = document.createElement("div");
    empty.className = "playerlist-empty";
    empty.textContent = "No players in this area.";
    list.appendChild(empty);
  }
}
